export default "__VITE_ASSET__DtPkmQS0__"